import { render, staticRenderFns } from "./BrandIconSlider.vue?vue&type=template&id=5b00464c&scoped=true&"
import script from "./BrandIconSlider.vue?vue&type=script&lang=js&"
export * from "./BrandIconSlider.vue?vue&type=script&lang=js&"
import style0 from "./BrandIconSlider.vue?vue&type=style&index=0&id=5b00464c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00464c",
  null
  
)

export default component.exports